import { LitElement, html, svg } from 'lit';

export class IconDownload32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Pil ned til harddisk</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.001 5v16M10.06 15.058 16.002 21l5.942-5.942M1 21.155V23a4 4 0 0 0 4 4h22a4 4 0 0 0 4-4v-1.845"></path></svg>`; }
}
if (!customElements.get('f-icon-download32', IconDownload32)) {
  customElements.define('f-icon-download32', IconDownload32);
}